<div class="loc-card-container">
  <div class="loc-card-header">
    <h2>{{title}}</h2>
  </div>
  <div class="loc-card-open-now">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
        fill="var(--dhcl-color-primary)"
      />
      <rect x="7.33398" y="3.33331" width="1.33333" height="6" rx="0.666667" fill="var(--dhcl-color-primary)" />
      <rect x="11.334" y="8" width="1.33333" height="4" rx="0.666667" transform="rotate(90 11.334 8)" fill="var(--dhcl-color-primary)" />
    </svg>
    <span *ngIf="isOpen && !is24HoursOpen" class="loc-card-open-now__hours">
      <strong *ngIf="!isClosingSoon else closingSoon">Open now</strong> {{getClosingString()}}</span
    >
    <span *ngIf="is24HoursOpen" class="loc-card-open-now__hours"> <strong>Open 24/7</strong></span>
    <ng-template #closingSoon>
      <strong>Closing soon</strong>
    </ng-template>
    <span *ngIf="!isOpen && !is24HoursOpen" class="loc-card-open-now__hours"> <strong>Closed now</strong> {{getOpeningString()}}</span>
  </div>
  <div class="loc-card-hours" *ngIf="!is24HoursOpen">
    <div *ngFor="let locationHours of hours; let i = index" class="loc-card-hours__row">
      <p *ngIf="getIsToday(locationHours.day)"><strong>{{locationHours.day}}</strong></p>
      <p *ngIf="getIsToday(locationHours.day) && locationHours.openTime !== ''">
        <strong
          >{{'2000-01-01T' + locationHours.openTime | date:"h:mm a"}} - {{this.today.toISO().split('T')[0]+ 'T' + locationHours.closeTime |
          date:"h:mm a"}}</strong
        >
      </p>
      <p *ngIf="getIsToday(locationHours.day) && locationHours.openTime === ''">
        <strong>Closed</strong>
      </p>
      <p *ngIf="!getIsToday(locationHours.day)">{{locationHours.day}}</p>
      <p *ngIf="!getIsToday(locationHours.day) && locationHours.openTime !== ''">
        {{'2000-01-01T' + locationHours.openTime | date:"h:mm a"}} - {{this.today.toISO().split('T')[0]+ 'T' + locationHours.closeTime |
        date:"h:mm a"}}
      </p>
      <p *ngIf="!getIsToday(locationHours.day) && locationHours.openTime === ''">Closed</p>
    </div>
  </div>
</div>
<div [ngClass]="{'fal-fal-modal': isChart}">
  <fal-fal-modal [events]="_additionalHours.asObservable()"></fal-fal-modal>
</div>
